import React from 'react';
import { ArticleBlock } from '../types/article';
import { RichText } from './RichText';
import { Checklist } from './Checklist';
import { Testimonials } from './Testimonials';
import { CtaButton } from './CtaButton';
import { TrustStrip } from './TrustStrip';
interface ArticleBodyProps {
  blocks: ArticleBlock[];
}
export function ArticleBody({
  blocks
}: ArticleBodyProps) {
  return <div data-id="element-1" data-mp="1dln0pmerlddb">
      {blocks.map((block, index) => {
      switch (block.kind) {
        case 'heading':
          return <h2 key={index} className="mb-4 mt-10 border-t border-forest-line pt-8 font-serif text-[26px] font-semibold leading-tight text-forest sm:text-[30px]" data-id="element-2" data-mp="19lct65bbqewc">
                {block.text}
              </h2>;
        case 'text':
          return <p key={index} className="mb-4 font-sans text-[17px] leading-[1.75] text-ink sm:text-[18px]" data-id="element-3" data-mp="2yxojpib1d2c1">
                <RichText text={block.text} data-id="element-4" data-mp="ysa5ia1nyj8l" />
              </p>;
        case 'quote':
          return <blockquote key={index} className="my-7 border-l-4 border-forest-mid pl-5" data-id="element-5" data-mp="13ptplql1lq8g">
                <p className="font-serif text-2xl font-medium italic leading-snug text-forest sm:text-[28px]" data-id="element-6" data-mp="18nveis55gjru">
                  {block.text}
                </p>
              </blockquote>;
        case 'image':
          return <figure key={index} className="my-8" data-id="element-7" data-mp="kzkji5m4xebh">
                <img src={block.src} alt={block.alt} className="w-full rounded-sm border border-forest-line object-cover" loading="lazy" data-id="element-8" data-mp="ky104656mn5h" />
              </figure>;
        case 'video':
          return <figure key={index} className="my-8" data-id="element-9" data-mp="29w11bzgzqd0">
                <video src={block.src} className="w-full rounded-sm border border-forest-line bg-black object-cover" autoPlay muted loop playsInline data-id="element-10" data-mp="28kwvb244gld" />
              </figure>;
        case 'checklist':
          return <Checklist key={index} items={block.items} data-id="element-11" data-mp="3v5aotm9czq6d" />;
        case 'callout':
          return <div key={index} className="my-8 rounded-sm border border-forest-line bg-paper-tint p-5 sm:p-6" data-id="element-12" data-mp="37fq0soycm2q8">
                <p className="font-sans text-xs font-bold uppercase tracking-widest text-forest-mid" data-id="element-13" data-mp="32i6i9cumb3sh">
                  {block.title}
                </p>
                <ul className="mt-4 space-y-3" data-id="element-14" data-mp="3ce9q8zc5hwnc">
                  {block.items.map(item => <li key={item} className="flex gap-3" data-id="element-15" data-mp="wn5ecti338ms">
                      <span className="mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full bg-forest" aria-hidden="true" data-id="element-16" data-mp="wprkqpt8ni3f" />
                      <span className="font-sans text-[17px] leading-relaxed text-ink" data-id="element-17" data-mp="z6iarxzx05k5">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>;
        case 'cta':
          return <div key={index} className="my-10" data-id="element-18" data-mp="u9rub9k777y7">
                <CtaButton label={`${block.label} →`} data-id="element-19" data-mp="1hykwhnreyc19" />
                <div className="mt-4" data-id="element-20" data-mp="1hz4bavlrokb2">
                  <TrustStrip data-id="element-21" data-mp="1mxnwuuwg7u2w" />
                </div>
              </div>;
        case 'reviews':
          return <Testimonials key={index} data-id="element-22" data-mp="196snlhi1fays" />;
        default:
          return null;
      }
    })}
    </div>;
}